import appAPI, { currentDomainOrganisation } from '@/api/modules/app.api.js';
import i18n from '@/common/i18n/i18n.js';
import { ErrorService } from '@/services/error-service.js';
import Config from '@/services/config.service';

const appConfig = new Config();

function blockAddDatasetIfQuotaExceeded(from, next) {
  const organisation = currentDomainOrganisation.value;
  if (appConfig.isSaas && organisation && organisation.quota_exceeded) {
    ErrorService.onError(null, i18n.t('messages.error.dataset.quotaExceeded'));
    if (from && from.name) {
      return next(false);
    }
    return next({ name: 'Datasets' });
  }
  return next();
}

export default [
  {
    path: 'data/datasets',
    name: 'Datasets',
    component: () => import('@/app/dataset/views/DatasetsView.vue'),
  },
  {
    path: 'data/datasets/new',
    name: 'AddDataset',
    component: () => import('@/app/dataset/views/NewDatasetView.vue'),
    beforeEnter: async (_to, from, next) => {
      if (appConfig.isSaas && !currentDomainOrganisation.value) {
        await appAPI.getCurrentDomainOrganisation();
      }
      blockAddDatasetIfQuotaExceeded(from, next);
    },
  },
  {
    path: 'data/datasets/:id',
    name: 'DatasetDetail',
    component: () => import('@/app/dataset/views/DatasetDetailView.vue'),
  },
  {
    path: 'data/datasets/:id/permissions',
    name: 'DatasetPermissions',
    component: () => import('@/app/dataset/views/DatasetPermissionsView.vue'),
    props: true
  },
];